export var EMPTY_VALUE = 'N/A';
export var FetchingStatus;

(function (FetchingStatus) {
  FetchingStatus[FetchingStatus["Initial"] = 1] = "Initial";
  FetchingStatus[FetchingStatus["Loading"] = 2] = "Loading";
  FetchingStatus[FetchingStatus["Failed"] = 3] = "Failed";
  FetchingStatus[FetchingStatus["Done"] = 4] = "Done";
  FetchingStatus[FetchingStatus["Refresh"] = 5] = "Refresh";
})(FetchingStatus || (FetchingStatus = {}));

export var ScopeType;

(function (ScopeType) {
  ScopeType["MySCP"] = "MYSCP";
  ScopeType["Care"] = "CARE";
  ScopeType["Practice"] = "PRACTICE";
  ScopeType["Connect"] = "CONNECT";
})(ScopeType || (ScopeType = {}));

export var UserPosition;

(function (UserPosition) {
  UserPosition["OPERATOR"] = "Operator";
  UserPosition["LEADERSHIP"] = "Leadership";
  UserPosition["SCHEDULER"] = "Scheduler";
  UserPosition["RECRUITER"] = "Recruiter";
  UserPosition["CREDENTIALER"] = "Credentialer";
  UserPosition["PROVIDER"] = "Provider";
  UserPosition["HM_PROVIDER"] = "HM Provider";
  UserPosition["EM_PROVIDER"] = "EM Provider";
  UserPosition["UC_PROVIDER"] = "UC Provider";
  UserPosition["OMS_PROVIDER"] = "OMS Provider";
  UserPosition["FIELD_OPERATOR"] = "Field Operator";
  UserPosition["GROUP_OPERATING_OFFICER"] = "Group Operating Officer";
  UserPosition["TDOC_PROVIDER"] = "Teladoc Provider";
  UserPosition["MEDICAL_LEADERSHIP"] = "Medical Leadership";
  UserPosition["MEDICAL_STAFF_LIAISON"] = "Medical Staff Liaison";
  UserPosition["PHYSICIAN"] = "Physician";
  UserPosition["NPPA"] = "NP/PA";
  UserPosition["CANDIDATE"] = "Candidate";
  UserPosition["EMPLOYEE"] = "Employee";
  UserPosition["OTHER"] = "Other";
  UserPosition["SUPER_ADMIN"] = "Super Admin";
  UserPosition["ADMIN"] = "Admin";
})(UserPosition || (UserPosition = {}));

export var UserType;

(function (UserType) {
  UserType["EMPLOYEE"] = "EMPLOYEE";
  UserType["CANDIDATE"] = "CANDIDATE";
})(UserType || (UserType = {}));

export var UsStatesAbbreviations;

(function (UsStatesAbbreviations) {
  UsStatesAbbreviations["AL"] = "AL";
  UsStatesAbbreviations["AK"] = "AK";
  UsStatesAbbreviations["AZ"] = "AZ";
  UsStatesAbbreviations["AR"] = "AR";
  UsStatesAbbreviations["CA"] = "CA";
  UsStatesAbbreviations["CO"] = "CO";
  UsStatesAbbreviations["CT"] = "CT";
  UsStatesAbbreviations["DE"] = "DE";
  UsStatesAbbreviations["FL"] = "FL";
  UsStatesAbbreviations["GA"] = "GA";
  UsStatesAbbreviations["HI"] = "HI";
  UsStatesAbbreviations["ID"] = "ID";
  UsStatesAbbreviations["IL"] = "IL";
  UsStatesAbbreviations["IN"] = "IN";
  UsStatesAbbreviations["IA"] = "IA";
  UsStatesAbbreviations["KS"] = "KS";
  UsStatesAbbreviations["KY"] = "KY";
  UsStatesAbbreviations["LA"] = "LA";
  UsStatesAbbreviations["ME"] = "ME";
  UsStatesAbbreviations["MD"] = "MD";
  UsStatesAbbreviations["MA"] = "MA";
  UsStatesAbbreviations["MI"] = "MI";
  UsStatesAbbreviations["MN"] = "MN";
  UsStatesAbbreviations["MS"] = "MS";
  UsStatesAbbreviations["MO"] = "MO";
  UsStatesAbbreviations["MT"] = "MT";
  UsStatesAbbreviations["NE"] = "NE";
  UsStatesAbbreviations["NV"] = "NV";
  UsStatesAbbreviations["NH"] = "NH";
  UsStatesAbbreviations["NJ"] = "NJ";
  UsStatesAbbreviations["NM"] = "NM";
  UsStatesAbbreviations["NY"] = "NY";
  UsStatesAbbreviations["NC"] = "NC";
  UsStatesAbbreviations["ND"] = "ND";
  UsStatesAbbreviations["OH"] = "OH";
  UsStatesAbbreviations["OK"] = "OK";
  UsStatesAbbreviations["OR"] = "OR";
  UsStatesAbbreviations["PA"] = "PA";
  UsStatesAbbreviations["RI"] = "RI";
  UsStatesAbbreviations["SC"] = "SC";
  UsStatesAbbreviations["SD"] = "SD";
  UsStatesAbbreviations["TN"] = "TN";
  UsStatesAbbreviations["TX"] = "TX";
  UsStatesAbbreviations["UT"] = "UT";
  UsStatesAbbreviations["VT"] = "VT";
  UsStatesAbbreviations["VA"] = "VA";
  UsStatesAbbreviations["WA"] = "WA";
  UsStatesAbbreviations["WV"] = "WV";
  UsStatesAbbreviations["WI"] = "WI";
  UsStatesAbbreviations["WY"] = "WY";
})(UsStatesAbbreviations || (UsStatesAbbreviations = {})); // NOTE: used only for US_STATES constant that is used for State select


export var UsStates;

(function (UsStates) {
  UsStates["AL"] = "Alabama";
  UsStates["AK"] = "Alaska";
  UsStates["AZ"] = "Arizona";
  UsStates["AR"] = "Arkansas";
  UsStates["CA"] = "California";
  UsStates["CO"] = "Colorado";
  UsStates["CT"] = "Connecticut";
  UsStates["DE"] = "Delaware";
  UsStates["FL"] = "Florida";
  UsStates["GA"] = "Georgia";
  UsStates["HI"] = "Hawaii";
  UsStates["ID"] = "Idaho";
  UsStates["IL"] = "Illinois";
  UsStates["IN"] = "Indiana";
  UsStates["IA"] = "Iowa";
  UsStates["KS"] = "Kansas";
  UsStates["KY"] = "Kentucky";
  UsStates["LA"] = "Louisiana";
  UsStates["ME"] = "Maine";
  UsStates["MD"] = "Maryland";
  UsStates["MA"] = "Massachusetts";
  UsStates["MI"] = "Michigan";
  UsStates["MN"] = "Minnesota";
  UsStates["MS"] = "Mississippi";
  UsStates["MO"] = "Missouri";
  UsStates["MT"] = "Montana";
  UsStates["NE"] = "Nebraska";
  UsStates["NV"] = "Nevada";
  UsStates["NH"] = "New Hampshire";
  UsStates["NJ"] = "New Jersey";
  UsStates["NM"] = "New Mexico";
  UsStates["NY"] = "New York";
  UsStates["NC"] = "North Carolina";
  UsStates["ND"] = "North Dakota";
  UsStates["OH"] = "Ohio";
  UsStates["OK"] = "Oklahoma";
  UsStates["OR"] = "Oregon";
  UsStates["PA"] = "Pennsylvania";
  UsStates["RI"] = "Rhode Island";
  UsStates["SC"] = "South Carolina";
  UsStates["SD"] = "South Dakota";
  UsStates["TN"] = "Tennessee";
  UsStates["TX"] = "Texas";
  UsStates["UT"] = "Utah";
  UsStates["VT"] = "Vermont";
  UsStates["VA"] = "Virginia";
  UsStates["WA"] = "Washington";
  UsStates["WV"] = "West Virginia";
  UsStates["WI"] = "Wisconsin";
  UsStates["WY"] = "Wyoming";
})(UsStates || (UsStates = {}));

export var Gender;

(function (Gender) {
  Gender["Male"] = "M";
  Gender["Female"] = "F";
  Gender["Other"] = "O";
  Gender["Unknown"] = "U";
})(Gender || (Gender = {}));